import {
  FiLayers,
  FiTrendingUp,
  FiClock,
  FiSearch,
  FiGlobe,
  FiEdit,
  FiBarChart2,
  FiShare,
  FiCheckSquare,
  FiCalendar,
  FiUserCheck,
  FiArchive,
} from 'react-icons/fi';
import { GiCash } from 'react-icons/gi';

export const governorTabs = [
  {
    title: 'Соҳалар',
    path: '/',
    icon: FiLayers,
    children: [{ title: 'Барча гуруҳлар', path: '/', id: 'all' }],
  },
  { title: 'Кунлик рейтинг', path: '/daily-rating', icon: FiTrendingUp },
  { title: 'Вақт кесимида', path: '/time-interval', icon: FiClock },
  { title: 'Ҳисобот', path: '/reports', icon: FiEdit },
  { title: 'Қидириш', path: '/search', icon: FiSearch },
  {
    title: 'Харитада кўриш',
    path: '/map',
    icon: FiGlobe,
  },
  // { title: 'Натижавий хисобот', path: '/statistics' },  //keyingi versionda qo'shiladi!
];
export const groupLeaderTabs = [
  {
    title: 'Соҳалар',
    path: '/',
    icon: FiLayers,
    children: [{ title: 'Барча гуруҳлар', path: '/', id: 'all' }],
  },
  { title: 'Кунлик рейтинг', path: '/daily-rating', icon: FiTrendingUp },
  { title: 'Вақт кесимида', path: '/time-interval', icon: FiClock },
  { title: 'Ҳисобот', path: '/reports', icon: FiEdit },
  { title: 'Қидириш', path: '/search', icon: FiSearch },
  {
    title: 'Харитада кўриш',
    path: '/map',
    icon: FiGlobe,
  },
  {
    title: 'Меҳнат интизоми',
    path: '/schedule',
    icon: FiCalendar,
  },
  {
    title: 'Тизимга уланганлик холати',
    path: '/payments',
    icon: FiCheckSquare,
  },
  {
    title: 'Махсус топшириқлар',
    path: '/special-tasks',
    icon: FiArchive,
  },

  // { title: 'Натижавий хисобот', path: '/statistics' },  //keyingi versionda qo'shiladi!
];
export const leaderTabs = [
  {
    title: 'Соҳалар',
    path: '/',
    icon: FiLayers,
    children: [],
  },
  { title: 'Кунлик рейтинг', path: '/daily-rating', icon: FiTrendingUp },
  { title: 'Вақт кесимида', path: '/time-interval', icon: FiClock },
  { title: 'Ҳисобот', path: '/reports', icon: FiEdit },
  { title: 'Қидириш', path: '/search', icon: FiSearch },
  {
    title: 'Харитада кўриш',
    path: '/map',
    icon: FiGlobe,
  },
  // { title: 'Натижавий хисобот', path: '/statistics' },  //keyingi versionda qo'shiladi!
];

export const secretaryTabs = [
  { title: 'Соҳалар', path: '/', icon: FiLayers },
  { title: 'Кунлик рейтинг', path: '/daily-rating', icon: FiTrendingUp },
  { title: 'Вақт кесимида', path: '/time-interval', icon: FiClock },
  { title: 'Диагамма', path: '/diagramma', icon: FiBarChart2 },
  { title: 'Юборилган ишлар', path: '/sent-works', icon: FiShare },
  { title: 'Янги ишлар', path: '/new-works', icon: FiCheckSquare },
];
